
import { useCrawlerState } from './useCrawlerState';
import { useCrawlerOperations } from './useCrawlerOperations';
import { useProgressTracking } from '@/hooks/useProgressTracking';
import { useComparisonState } from '@/hooks/useComparisonState';

export function useCrawler() {
  // Get the crawler state
  const {
    isAnalyzing,
    setIsAnalyzing,
    crawlResult,
    setCrawlResult,
    websiteUrl,
    setWebsiteUrl,
    sitemapStats,
    setSitemapStats,
    clearCrawlResults
  } = useCrawlerState();

  // Get progress tracking
  const { progress, handleProgressUpdate } = useProgressTracking();

  // Get comparison state
  const { compareMode, comparisonResult, compareWithHistory, clearComparison } = useComparisonState();

  // Get crawler operations
  const { handleSubmit, handleCancel } = useCrawlerOperations({
    setIsAnalyzing,
    setCrawlResult,
    setWebsiteUrl,
    setSitemapStats,
    handleProgressUpdate
  });

  return {
    isAnalyzing,
    progress,
    crawlResult,
    websiteUrl,
    compareMode,
    comparisonResult,
    sitemapStats,
    setCrawlResult,
    clearCrawlResults,
    handleSubmit,
    handleCancel,
    compareWithHistory,
    clearComparison
  };
}
